export let baseCol = {
	sortable: true,
	editable: false,
	filter: true,
	floatingFilter: true,
}

export let textCol = {
	filter: "agTextColumnFilter",
	resizable: true,
}

export let htmlCol = {
	filter: "agTextColumnFilter",
	resizable: true,
	cellRenderer: htmlCellRenderer,
}

export let fileCol = {
	filter: "agTextColumnFilter",
	resizable: true,
	cellRenderer: downloadCellRenderer,
}

export let linkCol = {
	filter: "agTextColumnFilter",
	resizable: true,
	cellRenderer: linkCellRenderer,
}

export let setCol = {
	filter: "agSetColumnFilter",
	resizable: true,
	filterParams: {
		defaultToNothingSelected: true,
	}
}

export let idCol = {
	filter: "agTextColumnFilter",
	minWidth: 60,
	resizable: true,
}

export let multiFilterCol = {
	filter: 'agTextColumnFilter',
	filterParams: {
		filterOptions: ['contains'],
		debounceMs: 200,
		textMatcher: function (params) {
			const value = params.value;
			const filterText = params.filterText;

			if (!filterText) return true;
			if (!value) return false;

			const searchIds = filterText
				.split(/[,\s]+/)
				.map(id => id.trim())
				.filter(id => id !== '');
			return searchIds.includes(value.toString());
		}
	}
}


export let idNumberCol = {
	filter: "agNumberColumnFilter",
	type: "numericColumn",
	minWidth: 60,
	resizable: true,
}

export let numberCol = {
	filter: "agNumberColumnFilter",
	valueFormatter: params => {
		const value = params.value;
		const currencyRegex = /[^\d.-]/;

		if (currencyRegex.test(value)) {
			return value;
		}

		return isNaN(parseFloat(value)) ? null : parseFloat(value);
	},
	filterValueGetter: params => {
		let value = params.data[params.colDef.field];
		if(typeof value === 'string') {
			value = value.replace(/[^\d.-]/g, '').replace(',', '.');
		}
		return isNaN(parseFloat(value)) ? null : parseFloat(value);
	},
	comparator: (valueA, valueB) => {
		let cleanedValueA = valueA;
		let cleanedValueB = valueB;
		if(typeof valueA === 'string') {
			cleanedValueA = valueA.replace(/[^\d.-]/g, '').replace(',', '.');
		}
		if(typeof valueB === 'string') {
			cleanedValueB = valueB.replace(/[^\d.-]/g, '').replace(',', '.');
		}
		const floatA = parseFloat(cleanedValueA);
		const floatB = parseFloat(cleanedValueB);
		if (isNaN(floatA) && isNaN(floatB)) return 0;
		if (isNaN(floatA)) return -1;
		if (isNaN(floatB)) return 1;
		return floatA - floatB;
	},
	type: "numericColumn",
	cellStyle: {
		textAlign: 'right',
	},
	resizable: true
}

export function htmlCellRenderer(params) {
	return params.value ? params.value : '';
}

window.htmlCellRenderer = htmlCellRenderer

export function downloadCellRenderer(params) {
	return "<a href='" + params.value + "' download><i class='fa fa-download'></i></a>";
}

window.downloadCellRenderer = downloadCellRenderer

export function linkCellRenderer(params) {
	if (params.value == null) {
		return "";
	} else if (params.value.toString().match(/\|/)) {
		let linkParts = params.value.toString().split('|')

		return "<a href='" + linkParts[0] + "' target='_blank'><i class='fa fa-link'></i> " + linkParts[1] + "</a>";
	} else {
		return "<a href='" + params.value + "' target='_blank'><i class='fa fa-link'></i></a>";
	}
}

window.linkCellRenderer = linkCellRenderer